import { makeStyles } from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';
import React from 'react';
import {
  Datagrid,
  List,
  Responsive,
  TextInput,
  SimpleList,
  TopToolbar,
  Pagination
} from 'react-admin';

import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';

const useStyles = makeStyles({
  textInput: {
    minWidth: '225px'
  },
  dataGridHead: {
    '& tr': {
      '& th:nth-of-type(1)': {
        width: '24px'
      }
    }
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const DocumentTypeFilters = props => {
  const classes = useStyles();

  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Document Type Name"
        source="description"
        alwaysOn
        className={classes.textInput}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
      />
    </Filter>
  );
};

const DocumentTypeTitle = props => {
  return (
    <ListTitleBar
      type="Document Types"
      title="Create New Document Type"
      createUrl="#/documenttypes/create"
      icon={<LayersIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const DocumentTypeList = props => {
  const classes = useStyles();
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'description', order: 'ASC' }}
      filter={{ scope: 'SPONSOR' }}
      exporter={false}
      title={<DocumentTypeTitle hasCreatePermission={hasCreatePermission} />}
      filters={<DocumentTypeFilters />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      bulkActionButtons={
        hasDeletePermission && (
          <BulkActionDeleteButton resource="documenttypes" />
        )
      }
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.description}
            secondaryText={record => record.id}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid
            classes={{ thead: hasDeletePermission && classes.dataGridHead }}
          >
            <LinkField label="Document Type Name" source="description" />
          </Datagrid>
        }
      />
    </List>
  );
};

export default DocumentTypeList;
